import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import DriverOnroadTest from "@/components/application/driver-onroad-test/DriverOnroadTest"
import AppLayout from "@/components/layout/AppLayout"

const DriverOnroadAssessmentPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          HIVED Partner Driver On-Road Assessment
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Complete the assessment to proceed with your application
        </p>

        <div className="mx-auto max-w-2xl">
          <DriverOnroadTest />
        </div>
      </div>
    </AppLayout>
  )
}

export default DriverOnroadAssessmentPage
